import React from 'react';

export default () => (
  <div style={{ maxWidth: '650px', margin: '0 auto' }}>
    <br />
    <br />
    <img
      style={{ height: '60px' }}
      src={'/images/inst-parchment-logo-color.png'}
      alt="Parchment logo"
    />
    <br />
    <br />
    <h5>TERMS AND CONDITIONS FOR SCRIBBLES SIGNATURE SERVICES</h5>
    <br />
    <h3>Effective: February 6, 2018</h3>
    <br />
    <strong>
      IMPORTANT NOTICE: THESE TERMS AND CONDITIONS CONTAIN A BINDING ARBITRATION
      PROVISION AND WAIVER OF JURY TRIALS AND CLASS ACTIONS GOVERNING DISPUTES
      ARISING FROM USE OF THE SCRIBBLES SOFTWARE SIGNATURE SERVICES. IT AFFECTS
      YOUR LEGAL RIGHTS AS DETAILED IN THE MANDATORY ARBITRATION AND WAIVER OF
      CLASS ACTION SECTION BELOW. PLEASE READ CAREFULLY.
    </strong>
    <br />
    <br />

    <p>
      <h5>First Things First</h5>
      <h5>These “Terms and Conditions” Form a Part of a Binding “Contract”</h5>
      <p>
        These Scribbles Signature Services Terms and Conditions (“Terms”) govern
        access to and use of the Scribbles Software, LLC (“Scribbles,” “we”,
        “our”, or “us”) web sites and services (collectively, the “Site”) by
        site visitors (“Site Visitors”) and by individuals or entities who
        purchase (or otherwise obtain the right to use) Scribbles Signature
        Services (“Services”) or create an account (“Account”) and their
        Authorized Users (collectively, “Customers”).
      </p>
    </p>

    <p>
      <h5>Who is “Site Visitor” or “Customer”?</h5>

      <p>
        By using the Site or any Services you are a Site Visitor and may be a
        Customer. You as a Site Visitor or Customer accept these Terms (whether
        on behalf of yourself or a legal entity you represent). An “Authorized
        User” of a Customer is each an individual natural person, whether an
        employee, business partner, contractor, or agent of a Customer who is
        registered or permitted by Customer to use the Services subject to these
        Terms and up to any maximum number of users or uses specified at the
        time of purchase. Customers and Site Visitors may be referred to in
        these Terms as “you” and “your” as applicable.
      </p>
      <p>
        If you are a Site visitor or Customer, you or your organization are also
        bound by Customer Terms of Service with Scribbles (“Customer Terms”)
        located online at{' '}
        <a href="https://scribsoft.com/customer-responsibilities.html">
          https://scribsoft.com/customer-responsibilities.html.
        </a>{' '}
        In the event of any conflict between the Customer Terms and these Terms,
        these Terms will control. For the avoidance of doubt, all references to
        the “Site” in these Terms also include any services provided by
        Scribbles.
      </p>
      <p>
        BY ACCESSING, USING, OR DOWNLOADING ANY MATERIALS FROM THE SITE, YOU
        AGREE TO FOLLOW AND BE BOUND BY THESE TERMS. IF YOU DO NOT AGREE TO
        THESE TERMS, YOU ARE NOT AUTHORIZED AND MUST CEASE USING THE SITE
        IMMEDIATELY.
      </p>
      <p>1. UPDATES AND COMMUNICATIONS</p>
      <p>
        1.1 We may revise these Terms or any additional terms and conditions
        that are relevant to a particular Scribbles service from time to time to
        reflect changes in the law or to any such services. We will post the
        revised terms on the Site with an “Effective” date. PLEASE REVIEW THE
        SITE ON A REGULAR BASIS TO OBTAIN TIMELY NOTICE OF ANY REVISIONS. IF YOU
        CONTINUE TO USE THE SERVICES AFTER THE REVISIONS TAKE EFFECT, YOU AGREE
        TO BE BOUND BY THE REVISED TERMS. You agree that we shall not be liable
        to you or to any third party for any modification of the Terms.
      </p>
      <p>
        1.2 You agree to receive all communications, agreements, and notices
        that we provide in connection with any Scribbles services
        (“Communications”), including, but not limited to, Communications
        related to our delivery of the Services and your purchase of or
        subscription to the Services, via electronic means, including by e-mail,
        text, in-app notifications, or by posting them on the Site or through
        any Scribbles services. You agree that all Communications we provide to
        you electronically satisfy any legal requirement that such
        Communications be in writing or be delivered in a particular manner and
        you agree to keep your Account contact information current.
      </p>
      <p>2. ADDITIONAL TERMS FOR SCRIBBLES SIGNATURE SERVICES</p>
      <p>
        2.1 Scribbles Signature Services. If you use Scribbles Signature
        Services, you accept the Terms of the Scribbles Signature Schedule
        below.
      </p>
      <p>
        2.2 Comments. If you use the “Comments” feature in Scribbles Signature
        Services, you accept the terms of the Comments Attachment below.
      </p>
      <p>3. USAGE AND ACCESS RIGHTS</p>
      <p>
        3.1 Eligibility to Use. You represent and warrant that you are: (a) of
        legal age (18 years of age or older or otherwise of legal age in your
        resident jurisdiction) and competent to agree to these Terms; and (b)
        you (or your Authorized Users, as applicable) are not and will not when
        using the Site be located in, under the control of, or a national or
        resident of a U.S. embargoed country or territory and are not a
        prohibited end user under Export Control Laws (as defined in Section
        12.3). You acknowledge that you are not permitted to use the Site if you
        cannot make these representations. If Scribbles has previously
        prohibited you from accessing the Site or using Scribbles Signature
        Services, you are not permitted to access the Site or use the Scribbles
        Signature Services. If you are agreeing to these Terms on behalf of an
        organization or entity, you represent and warrant that you are
        authorized to agree to these Terms on that organization or entity’s
        behalf and bind them to these Terms (in which case, the references to
        "you" and "your" in these Terms, except for in this sentence, refer to
        that organization or entity).
      </p>
      <p>
        3.2 Limited License. Upon your acceptance of these Terms, we grant you a
        limited, non-exclusive and non-transferable license to access and use
        the Site for your internal business, or personal purposes and only as
        expressly permitted in these Terms and any applicable Customer plan that
        enables registration of an Account for the use of Scribbles Signature
        Services or any other services provided by Scribbles (“Subscription
        Plan”) when applicable. You shall not use or permit use of the Site for
        any illegal purpose or in any manner inconsistent with the provisions of
        these Terms. If you are or become a direct competitor of Scribbles, you
        may not access or use any services provided by Scribbles without
        Scribbles’ explicit written consent, and then only for the purposes
        authorized in writing. Except as otherwise restricted by these Terms,
        Scribbles grants you permission on a non-exclusive, non-transferable,
        limited basis to display, copy, and download content and materials on
        the Site provided that you: (a) retain all copyright and other
        proprietary notices on the content and materials; (b) use them solely
        for personal or internal, non- commercial use or in accordance with any
        applicable Subscription Plan; and (c) do not modify them in any way.
        Each discrete Subscription Plan includes restrictions and requirements
        that outline the features that Customer will be able to access. Any
        violation by you of the license provisions contained in this Section 3
        may result in the immediate termination of your right to use the Site,
        as well as potential liability for copyright infringement or other
        claims depending on the circumstances.
      </p>
      <p>4. OWNERSHIP</p>
      <p>
        4.1 Intellectual Property. The Site contains materials that are
        proprietary and are protected by copyright laws, international treaty
        provisions, trademarks, service marks, and other intellectual property
        laws and treaties.
      </p>
      <p>
        4.1.1 The Site is also protected as a collective work or compilation
        under copyright and other laws and treaties. You agree to abide by all
        applicable copyright and other laws, as well as any additional copyright
        notices or restrictions contained on the Site. You acknowledge that the
        Site contains original works that have been developed, compiled,
        prepared, revised, selected, and arranged by Scribbles and others
        through the application of methods and standards of judgment developed
        and applied through the expenditure of substantial time, effort, and
        money and which constitute valuable intellectual property of Scribbles
        and such others. All present and future rights in and to trade secrets,
        patents, designs, copyrights, trademarks, database rights, service
        marks, know-how, and other intellectual property or other proprietary
        rights of any type, Documentation, any improvements, design
        contributions, or derivative works thereto, and any knowledge or process
        related thereto, including rights in and to all applications and
        registrations relating to the Site, shall, as between you and Scribbles,
        at all times be and remain the sole and exclusive property of Scribbles.
      </p>
      <p>
        4.1.2 The trademarks, logos, taglines, and service marks displayed on
        the Site (collectively, the “Trademarks”) are registered and
        unregistered Trademarks of Scribbles and others. The Trademarks may not
        generally be used in any advertising or publicity, or otherwise to
        indicate Scribbles’ sponsorship of or affiliation with any product,
        service, event, or organization without Scribbles’ prior express written
        permission. Scribbles acknowledges the Trademarks of other organizations
        for their respective products or services mentioned on the Site. Any
        rights not expressly granted in these Terms or a Subscription Plan are
        reserved by Scribbles. Other than as provided in these Terms or a
        Subscription Plan, your use of the Trademarks, or any other Scribbles
        content, is strictly prohibited.
      </p>
      <p>
        4.1.3 Copyright. Scribbles respects copyright law and expects its users
        to do the same. If you believe that any content or material on the Site
        infringes copyrights you own, please notify us.
      </p>
      <p>
        4.2 Software Use Restrictions. Software available for downloading
        through the Site or third-party websites or applications (the
        “Software”) is the copyrighted work of Scribbles or third-party
        providers (as applicable). Use of the Software is governed by these
        Terms. Unauthorized reproduction or distribution of the Software is
        expressly prohibited by law, and may result in civil and criminal
        penalties. Violators may be prosecuted.
      </p>
      <p>4.3 Non-Electronic Document Content and Submissions/User Content.</p>
      <p>
        4.3.1 Submissions. The Site or Services may enable you to submit, post,
        upload, or otherwise make available (collectively, "Post") content such
        as questions, public messages, ideas, product feedback, comments, and
        other content (collectively, "User Content") that may or may not be
        viewable by other users. If you Post User Content, unless we indicate
        otherwise, you grant us a nonexclusive, royalty-free, and fully
        sublicensable right to access, view, use, reproduce, modify, adapt,
        publish, translate, create derivative works from, distribute, copy, and
        display such User Content throughout the world in any form, media, or
        technology now known or hereafter developed. You also permit any other
        user to view, copy, access, store, or reproduce such User Content for
        that user’s personal use. You grant us the right to use the name and
        other information about you that you submit in connection with such User
        Content. You represent and warrant that: (a) you own or otherwise
        control all of the rights to the User Content that you Post; (b) the
        User Content you Post is truthful and accurate; and (c) use of the User
        Content you Post does not violate these Terms or any applicable laws.
        For the avoidance of doubt, User Content does not include any document,
        such as a contract, disclosure, or notice that you deposit into
        Scribbles Signature Services for processing (“Electronic Documents”).
      </p>
      <p>
        4.3.2 Screening & Removal.You acknowledge and agree that Scribbles and
        its designees may or may not, at Scribbles’ discretion, pre-screen User
        Content before its appearance on the Site or any Services, but that
        Scribbles has no obligation to do so. You further acknowledge and agree
        that Scribbles reserves the right (but does not assume the obligation)
        in its sole discretion to reject, move, edit, or remove any User Content
        that is contributed to the Site or any Services. Without limiting the
        foregoing, Scribbles and its designees shall have the right to remove
        any User Content that violates these Terms or is otherwise objectionable
        in Scribbles’ sole discretion. You acknowledge and agree that Scribbles
        does not verify, adopt, ratify, or sanction User Content, and you agree
        that you must evaluate and bear all risks associated with your use of
        User Content or your reliance on the accuracy, completeness, or
        usefulness of User Content.
      </p>
      <p>5. RESTRICTIONS ON USE OF THE SITE</p>
      <p>
        5.1 By using the Site, including any services provided by Scribbles, you
        specifically agree not to engage in any activity or transmit any
        information that, in our sole discretion:
      </p>
      <p>
        a) Is illegal, or violates any federal, state, or local law or
        regulation;
      </p>
      <p>
        b) Advocates illegal activity or discusses illegal activities with the
        intent to commit them;
      </p>
      <p>
        c) Violates any third-party right, including, but not limited to, right
        of privacy, right of publicity, copyright, trademark, patent, trade
        secret, or any other intellectual property or proprietary rights;
      </p>
      <p>
        d) Is harmful, threatening, abusive, harassing, tortious, indecent,
        defamatory, sexually explicit or pornographic, discriminatory, vulgar,
        profane, obscene, libelous, hate speech, violent or inciting violence,
        inflammatory, or otherwise objectionable;
      </p>
      <p>
        e) Interferes with any other party’s use and enjoyment of the Services
        or any other services provided by us;
      </p>
      <p>f) Attempts to impersonate another person or entity;</p>
      <p>
        g) Is commercial in a way that violates these Terms, including but not
        limited to, using the Site for spam, surveys, contests, pyramid schemes,
        or other advertising materials;
      </p>
      <p>
        h) Falsely states, misrepresents, or conceals your affiliation with
        another person or entity;
      </p>
      <p>i) Accesses or uses the account of another user without permission;</p>
      <p>
        j) Distributes computer viruses or other code, files, or programs that
        interrupt, destroy, or limit the functionality of any computer software
        or hardware or electronic communications equipment;
      </p>
      <p>
        k) Interferes with, disrupts, disables, overburdens, or destroys the
        functionality or use of any features of the Site, or the servers or
        networks connected to the Site, or any of the services provided by us;
      </p>
      <p>
        l) “Hacks” or accesses without permission our proprietary or
        confidential records, those of another user, or those of anyone else;
      </p>
      <p>
        m) Improperly solicits personal or sensitive information from other
        users including without limitation address, credit card or financial
        account information, or passwords;
      </p>
      <p>
        n) Decompiles, reverse engineers, disassembles, or otherwise attempts to
        derive source code from the Site, except as expressly permitted in these
        Terms or by law, unless and then only to the extent permitted by
        applicable law without consent;
      </p>
      <p>
        o) Removes, circumvents, disables, damages, or otherwise interferes with
        security- related features, or features that enforce limitations on use
        of the Site;
      </p>
      <p>
        p) Uses automated or manual means to violate the restrictions in any
        robot exclusion headers on the Site, if any, or bypasses or circumvents
        other measures employed to prevent or limit access, for example by
        engaging in practices such as “screen scraping,” “database scraping,” or
        any other activity with the purpose of obtaining lists of users or other
        information;
      </p>
      <p>
        q) Modifies, copies, scrapes or crawls, displays, distributes,
        publishes, licenses, sells, rents, leases, lends, transfers, or
        otherwise commercializes any materials or content on the Site;
      </p>
      <p>
        r) Uses the Services for benchmarking, or to compile information for a
        product or service;
      </p>
      <p>
        s) Downloads (other than through page caching necessary for personal
        use, or as otherwise expressly permitted by these Terms), distributes,
        posts, transmits, performs, reproduces, broadcasts, duplicates, uploads,
        licenses, creates derivative works from, or offers for sale any content
        or other information contained on or obtained from or through the Site
        or the Services, by any means except as provided for in these Terms or
        with the prior written consent of Scribbles; or
      </p>
      <p>t) Attempts to do any of the foregoing.</p>
      <p>
        If you believe content on the Site violates the above restrictions,
        please contact us at:{' '}
        <a href="mailto:ethics@scribsoft.com">ethics@scribsoft.com.</a>
      </p>
      <p>
        5.2 In addition, Customers shall not, and shall not permit others to, do
        the following with respect to the Services:
      </p>
      <p>
        a) Use the Services or allow access to them in a manner that circumvents
        contractual usage restrictions or that exceeds authorized use or usage
        metrics set forth in these Terms, any applicable Subscription Plan or
        any applicable Customer Terms;
      </p>
      <p>
        b) License, sub-license, sell, re-sell, rent, lease, transfer,
        distribute or time share or otherwise make any portion of the Services
        or Scribbles’ then-current technical and functional documentation for
        the Services (“Documentation”) available for access by third parties
        except as otherwise expressly provided in these Terms; or
      </p>
      <p>
        c) Access or use the Services or Documentation for the purpose of
        developing or operating products or services intended to be offered to
        third parties in competition with the Services or allow access by a
        direct competitor of Scribbles.
      </p>
      <p>
        5.3 You may not frame the Site, place pop-up windows over its pages, or
        otherwise affect the display of its pages. You may link to the Site,
        provided that you acknowledge and agree that you will not link the Site
        to any website containing any inappropriate, profane, defamatory,
        infringing, obscene, indecent, or unlawful topic, name, material, or
        information or that violates any intellectual property, proprietary,
        privacy, or publicity rights. Any violation of this provision may, in
        our sole discretion, result in termination of your use of and access to
        the Site effective immediately.
      </p>
      <p>
        5.4 You acknowledge that we have no obligation to monitor your – or
        anyone else’s – access to or use of the Site for violations of these
        Terms, or to review or edit any content. However, we have the right to
        do so for the purpose of operating and improving the Site (including
        without limitation for fraud prevention, risk assessment, investigation
        and customer support purposes, analytics, and advertising), to ensure
        your compliance with these Terms and to comply with applicable law or
        the order or requirement of a court, consent decree, administrative
        agency or other governmental body.
      </p>
      <p>6. PRIVACY</p>
      <p>
        6.1 Scribbles Privacy Policy. You acknowledge that except as described
        in these Terms or applicable Customer Terms, the information you provide
        to us or that we collect will be used and protected as described in the
        Scribbles Privacy Policy located online at{' '}
        <a href="https://scribsoft.com/privacy-policy.html">
          https://scribsoft.com/privacy-policy.html.
        </a>{' '}
        Please read that Privacy Policy carefully.
      </p>
      <p>
        6.2 Access & Disclosure. We may access, preserve, or share any of your
        information when we believe in good faith that such sharing is
        reasonably necessary to investigate, prevent, or take action regarding
        possible illegal activities or to comply with legal process (e.g. a
        subpoena or other legal process). We may also share your information in
        situations involving potential threats to the physical safety of any
        person, violations of the Scribbles Privacy Policy or our user
        agreements or terms; or to respond to the claims of violation of the
        rights of third parties and/or to protect the rights, property and
        safety of Scribbles, our employees, users, or the public. This may
        involve the sharing of your information with law enforcement, government
        agencies, courts, and/or other organizations.
      </p>
      <p>7. TERMS SPECIFIC TO SCRIBBLES SERVICES</p>
      <p>
        7.1 Right to Use the Services. Subject to these Terms, Scribbles will
        provide the Services to Customers in accordance with each Customer’s
        Subscription Plan, and Scribbles grants to each Customer a limited
        non-exclusive, non-transferrable right and license during the Term,
        solely for its internal business purposes and in accordance with the
        Documentation, to: (a) use the Services; (b) implement, configure, and,
        through its Account Administrator(s), permit its Authorized Users to
        access and use the Services up to any applicable limits or maximums; and
        (c) access and use the Documentation.
      </p>
      <p>
        7.1.1 Authorized Users. Authorized Users of Customer must be identified
        by a unique email address and/or user name and two or more natural
        persons may not use the Services as the same Authorized User. If the
        Authorized User is not an employee of Customer, use of the Scribbles
        Services will be allowed only if the user is under confidentiality and
        other obligations with Customer at least as restrictive as those in
        these Terms, and is accessing or using the Services solely to support
        Customer’s internal business purposes.
      </p>
      <p>
        7.1.2 Account Administrator.Customer may assign and expressly authorize
        an Authorized User(s) as its agent to manage Customer’s Account, and
        management of Customer’s Account includes, without limitation,
        configuring administration settings, assigning access and use
        authorization, requesting different or additional services, providing
        usage and performance records, managing templates, executing approved
        campaigns and events, assisting in third-party product integrations, and
        accepting notices, disclosures, and terms and conditions (“Account
        Administrator”). Customer may appoint an employee, agent or a
        third-party business partner or contractor to act as its Account
        Administrator(s) and may change its designation at any time through its
        Account.
      </p>
      <p>7.2 Payment Terms.</p>
      <p>
        7.2.1 Subscription Plan. The prices, features, and options of the
        Services may depend on the Subscription Plan selected, if any, as well
        as any changes instigated by Customer. Scribbles does not represent or
        warrant that a particular Subscription Plan will be offered indefinitely
        and reserves the right to change the prices for or alter the features
        and options in a particular Subscription Plan without prior notice.
      </p>
      <p>
        7.2.2 No Refunds. Customer will timely pay Scribbles all fees associated
        with its Subscription Plan, Account, or use of the Services, including,
        but without limitation, by Authorized Users. CUSTOMER’S PAYMENTS ARE
        NON-REFUNDABLE EXCEPT AS EXPRESSLY PROVIDED IN THESE TERMS. Charges for
        pre-paid Subscription Plans, if applicable, will be billed to Customer
        in advance. Charges for per-use purchases and standard Subscription Plan
        charges will be billed at the time of order unless otherwise specified.
      </p>
      <p>
        7.2.3 Recurring Charges. If and when you purchase a Subscription Plan,
        you must provide accurate and complete information for a valid payment
        method that you are authorized to use. You will be billed for your
        Subscription Plan either through the payment method you provide, such as
        a credit card or electronic funds transfer. Customer must promptly
        notify Scribbles of any change in its invoicing address and must update
        its Account with any changes related to its payment method.BY COMPLETING
        REGISTRATION FOR A SUBSCRIPTION PLAN, CUSTOMER AUTHORIZES SCRIBBLES OR
        ITS AGENT TO CHARGE ITS PAYMENT METHOD ON A RECURRING (E.G. MONTHLY OR
        YEARLY) BASIS (“AUTHORIZATION”) FOR: (a) ANY APPLICABLE SUBSCRIPTION
        PLAN CHARGES; (b) ANY AND ALL APPLICABLE TAXES; AND (c) ANY OTHER
        CHARGES INCURRED IN CONNECTION WITH CUSTOMER’S USE OF THE SERVICES. The
        Authorization continues through the applicable Subscription Term and any
        Renewal Term (as defined in Section 8.2.3, below) until Customer cancels
        as set forth in Section 8.2 of these Terms.
      </p>
      <p>
        7.2.4 Late Fees & Collection Costs. If Scribbles does not receive
        payment from Customer’s payment method, Customer agrees to pay all
        amounts due upon demand. Any amount not paid when due will be subject to
        finance charges equal to 1.5% of the unpaid balance per month or the
        highest rate permitted by applicable law, whichever is less, determined
        and compounded daily from the date due until the date paid. Customer
        will reimburse any costs or expenses (including, but not limited to,
        reasonable attorneys’ fees) incurred by Scribbles to collect any amount
        that is not paid when due. Scribbles may accept payment in any amount
        without prejudice to Scribbles’ right to recover the balance of the
        amount due or to pursue any other right or remedy. Amounts due to
        Scribbles may not be withheld or offset by Customer for any reason
        against amounts due or asserted to be due from Scribbles.
      </p>
      <p>
        7.2.5 Invoices. Scribbles will provide billing and usage information in
        a format we choose, which may change from time to time. Scribbles
        reserves the right to correct any errors or mistakes that it identifies
        even if it has already issued an invoice or received payment. Customer
        agrees to notify us about any billing problems or discrepancies within
        thirty (30) days after they first appear on your invoice. If Customer
        does not bring such problems/discrepancies to our attention within
        thirty (30) days, it agrees to waive its right to dispute such problems
        or discrepancies.
      </p>
      <p>
        7.2.6 Billing Cycles. Billing cycle end dates may change from time to
        time. When a billing cycle covers less than or more than a full month,
        we may make reasonable adjustments and/or prorations. Customer agrees
        that we may (at our option) accumulate charges incurred during a billing
        cycle and submit them as one or more aggregate charges during or at the
        end of a cycle, and that we may delay obtaining authorization or payment
        from Customer’s payment card issuer or bank account until submission of
        the accumulated charge(s).
      </p>
      <p>
        7.2.7 Benefit Programs. You may receive or be eligible for certain
        pricing structures, discounts, features, promotions, and other benefits
        (collectively, "Benefits") through a business or government agreement
        with us ("Business Terms"). Any and all such Benefits are provided
        solely as a result of the corresponding Business Terms and such Benefits
        may be modified or terminated without notice. If you use the Services
        and a business or government entity pays your charges or is otherwise
        liable for the charges, you authorize us to share your account
        information with that entity and/or its authorized agents. If you are
        enrolled in a Subscription Plan or receive certain Benefits tied to
        Business Terms with us, but you are liable for your own charges, then
        you authorize us to share enough account information to verify your
        continuing eligibility for those Benefits and the Subscription Plan.
      </p>
      <p>
        7.2.8 Tax Responsibility. All payments required by these Terms are
        stated exclusive of all taxes, duties, levies, imposts, fines, or
        similar governmental assessments, including sales and use taxes,
        value-added taxes (“VAT”), goods and services taxes (“GST”), excise,
        business, service, and similar transactional taxes imposed by any
        jurisdiction and the interest and penalties thereon, excluding taxes
        based on Scribbles’ net income (collectively, “Taxes”). Customer shall
        be responsible for and bear Taxes associated with its purchase of,
        payment for, access to or use of any products or services provided by
        Scribbles to Customer. Taxes shall not be deducted from the payments to
        Scribbles, except as required by law, in which case Customer shall
        increase the amount payable as necessary so that after making all
        required deductions and withholdings, Scribbles receives and retains
        (free from any Tax liability) an amount equal to the amount it would
        have received had no such deductions or withholdings been made. Customer
        hereby confirms that Scribbles can rely on the name and address set
        forth in its registration for a Subscription Plan as being the place of
        supply for Tax purposes. Scribbles’ and Customer’s obligations under
        this Section 7.2.8 (Tax Responsibility) shall survive the termination or
        expiration of these Terms.
      </p>
      <p>7.3 Free Trial and Special Offers for Scribbles Services.</p>
      <p>
        7.3.1 If you register for a free trial, promotional offer, or other type
        of limited offer for use of Scribbles Services (“Free Trial”), you may
        be presented with additional terms and conditions when registering for a
        Free Trial, and any such additional terms and conditions are hereby
        incorporated into these Terms by reference and are legally binding. This
        Section 7.3 (Free Trial and Special Offers for Scribbles Services)
        supersedes and applies notwithstanding any conflicting provisions with
        regard to access and use of a Free Trial.
      </p>
      <p>
        7.3.2 Scribbles reserves the right to reduce the term of a trial period
        or end it altogether without prior notice.
      </p>
      <p>
        7.3.3 The version of any Scribbles services that is available for a Free
        Trial may not include or allow access to all features or functions. ANY
        DATA THAT A CUSTOMER ENTERS INTO THE SCRIBBLES SERVICES, AND ANY
        CONFIGURATIONS MADE BY OR FOR A CUSTOMER, DURING THE FREE TRIAL WILL BE
        PERMANENTLY LOST AT THE END OF THE TRIAL PERIOD UNLESS THE CUSTOMER: (a)
        PURCHASES A SUBSCRIPTION PLAN TO SCRIBBLES SERVICES THAT IS EQUIVALENT
        TO OR GREATER THAN THOSE COVERED BY THE TRIAL; OR (b) EXPORTS SUCH DATA
        BEFORE THE END OF THE TRIAL PERIOD.
      </p>
      <p>
        7.3.4 Notwithstanding any other provision of these Terms, including
        without limitation the warranties described in Section 9 (Warranties and
        Disclaimers) or any service-specific terms and conditions applicable to
        a particular Scribbles Service, including exhibits and attachments
        accompanying such schedule (“Service Schedule”), during a Free Trial the
        Scribbles Services are provided “AS IS” and “as available” without any
        warranty that may be set forth in these Terms, and SCRIBBLES DISCLAIMS
        ANY IMPLIED WARRANTIES INCLUDING WITHOUT LIMITATION MERCHANTABILITY OR
        FITNESS FOR A PARTICULAR PURPOSE AND SCRIBBLES’ TOTAL AGGREGATE
        LIABILITY ARISING OUT OF OR RELATING TO CUSTOMER’S USE OF THE FREE TRIAL
        IS $100.
      </p>
      <p>7.4 Data.</p>
      <p>
        7.4.1 Data Generally. You shall be responsible for data that you provide
        or use in any services provided by Scribbles. You are solely responsible
        for determining the suitability of any services provided by Scribbles
        for your business or organization and complying with any regulations,
        laws, or conventions applicable to the data you provide and your use of
        any services provided by Scribbles and Site.
      </p>
      <p>
        7.4.2 Personal Data. Customer warrants that its collection and use of
        any personal information or data provided while using the Site complies
        with all applicable data protection laws, rules, and regulations.
        Customer and its Authorized Users acknowledge that Scribbles may process
        such personal data in accordance with the Scribbles Privacy Policy.
      </p>
      <p>7.5 Customer Warranties.</p>
      <p>
        Customer hereby represents and warrants to Scribbles that: (a) it has
        all requisite rights and authority to use the Services under these Terms
        and to grant all applicable rights herein; (b) it is responsible for all
        use of the Services associated with its Account; (c) it is solely
        responsible for maintaining the confidentiality of its Account names and
        password(s); (d) it agrees to immediately notify Scribbles of any
        unauthorized use of Customer’s Account of which it becomes aware; (e) it
        agrees that Scribbles will not be liable for any losses incurred as a
        result of a third party's use of its Account, regardless of whether such
        use is with or without its knowledge and consent; (f) it will use the
        Services for lawful purposes only and subject to these Terms; (g) any
        information it submits to Scribbles is true, accurate, and correct; and
        (h) it will not attempt to gain unauthorized access to the System or the
        Services, other accounts, computer systems, or networks under the
        control or responsibility of Scribbles through hacking, cracking,
        password mining, or any other unauthorized means.
      </p>
      <p>7.6 Confidentiality.</p>
      <p>
        7.6.1 Confidential Information. “Confidential Information” means (a) for
        Scribbles, the Services and Documentation; (b) for Customer, Customer
        Data; (c) any other information of a party that is disclosed in writing
        or orally and is designated as confidential or proprietary at the time
        of disclosure (and, in the case of oral disclosures, summarized in
        writing within thirty (30) days of the initial disclosure and delivered
        to the Recipient), or that due to the nature of the information the
        Recipient would clearly understand it to be confidential information of
        the disclosing party; and (d) the specific terms and conditions of these
        Terms, and any amendment and attachment thereof, between the parties.
        Confidential Information shall not include any information that: (i) was
        or becomes generally known to the public through no fault or breach of
        these Terms by the Recipient; (ii) was rightfully in the Recipient’s
        possession at the time of disclosure without restriction on use or
        disclosure; (iii) was independently developed by the Recipient without
        use of the disclosing party’s Confidential Information; or (iv) was
        rightfully obtained by the Recipient from a third party not under a duty
        of confidentiality and without restriction on use or disclosure. All
        information provided to Scribbles that is not Confidential Information
        will be treated in accordance with the Scribbles Privacy Policy.
      </p>
      <p>
        7.6.2 Restricted Use and Nondisclosure. During and after the
        Subscription Term, the party receiving Confidential Information
        (“Recipient”) will: (a)use the Confidential Information of the other
        party solely for the purpose for which it is provided; (b) not disclose
        such Confidential Information to a third party, except on a need-to-know
        basis to its attorneys, auditors, consultants, and service providers who
        are under confidentiality obligations at least as restrictive as those
        contained herein; and (c) protect such Confidential Information from
        unauthorized use and disclosure to the same extent (but using no less
        than a reasonable degree of care) that it protects its own Confidential
        Information of a similar nature. Notwithstanding the foregoing, Customer
        expressly authorizes Scribbles to use and process Customer Data as
        described in the Scribbles Privacy Policy, which provides for, but is
        not limited to, delivering Electronic Documents as indicated by
        Customer’s use of the Scribbles Services and sharing Transaction Data
        (as defined in the Signature Schedule) with individuals who are
        authorized to view, approve or sign Electronic Documents created by
        Customer.
      </p>
      <p>
        7.6.3 Required Disclosure. If Scribbles is required by law to disclose
        Confidential Information, Scribbles will give prompt written notice to
        Customer before making the disclosure, unless prohibited from doing so
        by the legal or administrative process, and assist Customer to obtain
        (at its own expense) where reasonably available an order protecting the
        Confidential Information from public disclosure.
      </p>
      <p>
        7.6.4 Ownership.Notwithstanding any other provision of these Terms,
        Scribbles acknowledges that, as between the parties, all Confidential
        Information it receives from Customer, including all copies thereof in
        Recipient’s possession or control, in any media, is proprietary to and
        exclusively owned by Customer. Nothing in these Terms grants Scribbles
        any right, title or interest in or to any of the Customer’s Confidential
        Information. Scribbles’ incorporation of the disclosing party’s
        Confidential Information into any of its own materials will not render
        Confidential Information non-confidential.
      </p>
      <p>8. TERM AND TERMINATION</p>
      <p>
        8.1 Termination – Site Visitors. A Site Visitor may terminate its use of
        the Site at any time by ceasing further use of the Site. Scribbles may
        terminate your use of the Site and deny you access to the Site in our
        sole discretion for any reason or no reason, including for violation of
        these Terms.
      </p>
      <p>8.2 Term and Termination – Customers.</p>
      <p>
        8.2.1 Suspension of Access to the Services. Scribbles may suspend any
        use of the Services, remove any content or disable or terminate any
        Account or Authorized User that Scribbles reasonably and in good faith
        believes violates these Terms. Scribbles will use commercially
        reasonable efforts to notify you prior to any such suspension or
        disablement, unless Scribbles reasonably believes that: (a) it is
        prohibited from doing so under applicable law or under legal process,
        such as court or government administrative agency processes, orders,
        mandates, and the like; or (b) it is necessary to delay notice in order
        to prevent imminent harm to the Services or a third party. Under
        circumstances where notice is delayed, Scribbles will provide the notice
        if and when the related restrictions in the previous sentence no longer
        apply.
      </p>
      <p>
        8.2.2 Term. The period of effectiveness of these Terms (“Term”), with
        respect to Services, begins on the date the Customer accepts it and
        continues until the Customer’s Subscription Plan expires or its use of
        the Services ceases (including as a result of termination in accordance
        with this Section 8.2), whichever is later.
      </p>
      <p>
        8.2.3 Subscription Term and Automatic Renewals.Scribbles’ Subscription
        Plans automatically renew unless otherwise noted. If you purchase a
        Subscription Plan you agree to pay the then-current applicable fee
        associated with the Subscription Plan and further agree and acknowledge
        that it will automatically renew, unless, prior to the end of the
        current period of effectiveness of the Subscription Plan (“Subscription
        Term”): (a) you terminate your Account; (b) you set your Account not to
        auto-renew by contacting Scribbles support at{' '}
        <a href="mailto:support@scribsoft.com">support@scribsoft.com</a> (c)
        Scribbles declines to renew your Subscription Plan; or (d) these Terms
        are otherwise properly terminated as expressly permitted herein. The
        Subscription Plan will automatically renew on a monthly or annual basis,
        depending on the method you choose (“Renewal Term”).
      </p>
      <p>
        Promotional codes may only be used for your first Subscription Term. If
        you purchased your Subscription Plan with a promotional code, each time
        your Subscription Plan renews you will be charged the full annual
        billing amount. If your Subscription Plan is ever terminated for any
        reason, and you purchase another Subscription Plan, you shall not be
        eligible to use a promotional code.
      </p>
      <p>
        We reserve the right to modify, terminate, or otherwise amend the fees
        and features associated with your Subscription Plan. We may also
        recommend that you purchase a new Subscription Plan that is comparable
        to your previous Subscription Plan that is ending. Before we change the
        fees and charges in effect, or add new fees and charges, we will give
        you advance notice of at least thirty (30) days. If we provide you such
        advance notice, your continued use of the Scribbles Services after the
        changes have been made will constitute your acceptance of the changes.
        If you do not wish to continue subscribing with the new fees or
        features, you may terminate your Subscription Plan as described in
        Section 8.2.4. If you accept the new Subscription Plan, its terms and
        conditions with these Terms will apply in the Renewal Term and
        thereafter.
      </p>
      <p>
        8.2.4 Termination by Customer. You may terminate your Account at any
        time by written notice to Scribbles. If you wish to terminate, you must
        provide notice by contacting us here:{' '}
        <a href="mailto:support@scribsoft.com">support@scribsoft.com</a>.
        Section 7.2.2 notwithstanding, if a Customer terminates its annual
        Subscription Plan within the first thirty (30) days of the initial
        Subscription Term, it may submit a written request to Scribbles for a
        refund of the fees paid to Scribbles for the initial Subscription Term,
        which Scribbles will consider, without obligation, in good faith.
        Scribbles has no obligation to consider refund requests related to a
        termination of a Subscription Plan if the termination does not occur in
        the first thirty (30) days of the initial Subscription Term, or if there
        has been a violation of other Terms herein, or if records indicate
        substantial productive use took place during that period.
      </p>
      <p>
        8.2.5 Default; Termination by Scribbles. A Customer will be in default
        of these Terms if: (a) it fails to timely pay any amount owed to us or
        an Affiliate of ours; (b) it or an Authorized User associated with its
        Account breaches any provision of these Terms or violates any published
        policy applicable to the Services; (c) it is or becomes subject to any
        proceeding under the Bankruptcy Code or similar laws; or (d) if, in our
        sole discretion, we believe that continued use of the Services by the
        Customer (or its Authorized Users or signers) creates legal risk for
        Scribbles or presents a threat to the security of the Services or any of
        Scribbles’ customers. If a Customer is in default, we may, without
        notice: (i) suspend its Account and use of the Services; (ii) terminate
        its Account; (iii) charge reactivation fees in order to reactivate its
        Account; and (iv) pursue any other remedy available to us. A Scribbles
        “Affiliate” means any legal entity that Scribbles owns, that owns
        Scribbles, or that is under common control with Scribbles, Inc. A
        Customer “Affiliate” means any legal entity that Customer owns, that
        owns Customer or that is under common control with Customer. “Control”
        and “own” mean possessing greater than 50% interest in an entity or the
        right to direct the management of the entity.
      </p>
      <p>
        8.2.6 Effect of Termination. If these Terms expires or are terminated
        for any reason: (a) Customer will pay to Scribbles any amounts that have
        accrued before, and remain unpaid as of, the date of the termination or
        expiration, including those for the billing cycle in which termination
        occurs; (b) any and all of Customer’s liabilities to Scribbles that have
        accrued before the effective date of the expiration or termination will
        survive; (c) licenses and use rights granted to Customer with respect to
        the Site and the Services and intellectual property will immediately
        terminate; (d) Scribbles’ obligation to provide any further services to
        Customer under these Terms will immediately terminate, except any such
        services that are expressly to be provided following expiration or
        termination of these Terms; and (e) the provisions of Section 3 (Usage
        and Access Rights), Section 4 (Ownership), Section 5.3 (Restrictions on
        Use of the Site), Section 5.4 (Compliance with Terms), Section 6
        (Privacy), Section 7.2.2 (No Refunds), Section 7.2.7 (Benefit Programs),
        Section 7.2.8 (Tax Responsibility), Section 7.3 (Free Trial and Special
        Offers for Scribbles Services), Section 7.4 (Data), Section 7.6
        (Confidentiality), Section 8.2.6 (Effect of Termination), Section 9
        (Warranties and Disclaimers), Section 10 (Indemnification Obligations),
        Section 11 (Limitations of Liability), and Section 12 (General) will
        survive, as well as provisions designated to survive under any Service
        Schedules and accompanying attachments and Exhibits to these Terms.
      </p>
      <p>9. WARRANTIES AND DISCLAIMERS</p>
      <p>
        THE SCRIBBLES SERVICES, DOCUMENTATION, AND SITE ARE PROVIDED “AS IS”AND
        “AS AVAILABLE.” YOUR USE OF THE SCRIBBLES SERVICES, DOCUMENTATION, AND
        SITE SHALL BE AT YOUR SOLE RISK. SCRIBBLES AND ITS RESPECTIVE OFFICERS,
        DIRECTORS, EMPLOYEES, MEMBERS, AGENTS, AFFILIATES, SUBSIDIARIES, AND
        LICENSORS (“SCRIBBLES PARTIES”): (a) MAKES NO ADDITIONAL REPRESENTATION
        OR WARRANTY OF ANY KIND WHETHER EXPRESS, IMPLIED (EITHER IN FACT OR BY
        OPERATION OF LAW), OR STATUTORY, AS TO ANY MATTER WHATSOEVER; (b)
        EXPRESSLY DISCLAIMS ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
        FOR A PARTICULAR PURPOSE, QUALITY, ACCURACY, AND TITLE; AND (c) DOES NOT
        WARRANT THAT THE SCRIBBLES SERVICES, DOCUMENTATION, OR SITE ARE OR WILL
        BE ERROR-FREE, WILL MEET YOUR REQUIREMENTS, OR BE TIMELY OR SECURE. YOU
        WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE RESULTING FROM USE OF THE
        SCRIBBLES SERVICES, DOCUMENTATION, OR SITE.
      </p>
      <p>
        THE SCRIBBLES PARTIES MAKE NO WARRANTIES OR REPRESENTATIONS THAT
        SCRIBBLES SERVICES, DOCUMENTATION, AND SITE HAVE BEEN AND WILL BE
        PROVIDED WITH DUE SKILL, CARE AND DILIGENCE OR ABOUT THE ACCURACY OR
        COMPLETENESS OF THE SCRIBBLES SERVICES, DOCUMENTATION, AND SITE CONTENT
        AND ASSUMES NO RESPONSIBILITY FOR ANY: (i) ERRORS, MISTAKES, OR
        INACCURACIES OF CONTENT; (ii) PERSONAL INJURY OR PROPERTY DAMAGE OF ANY
        NATURE WHATSOEVER RESULTING FROM YOUR ACCESS TO AND USE OF SCRIBBLES
        SERVICES, DOCUMENTATION, AND SITE; (iii) ANY UNAUTHORIZED ACCESS TO OR
        USE OF OUR SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR
        FINANCIAL INFORMATION STORED THEREIN; (iv) ANY INTERRUPTION OR CESSATION
        OF TRANSMISSION TO OR FROM THE SITE; (v) ANY BUGS, VIRUSES, TROJAN
        HORSES, OR THE LIKE THAT MAY BE TRANSMITTED TO OR THROUGH THE SITE
        THROUGH THE ACTIONS OF ANY THIRD PARTY; (vi) ANY LOSS OF YOUR DATA OR
        CONTENT FROM THE SITE; AND/OR (vii) ANY ERRORS OR OMISSIONS IN ANY
        CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF
        THE USE OF ANY CONTENT POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE
        AVAILABLE VIA SCRIBBLES SERVICES, DOCUMENTATION, AND SITE. YOU WILL NOT
        HAVE THE RIGHT TO MAKE OR PASS ON ANY REPRESENTATION OR WARRANTY ON
        BEHALF OF SCRIBBLES TO ANY THIRD PARTY. BECAUSE SOME STATES AND
        JURISDICTIONS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES, THE ABOVE
        LIMITATION MAY NOT APPLY TO YOU.IN THAT EVENT, SUCH WARRANTIES ARE
        LIMITED TO THE MAXIMUM EXTENT PERMITTED BY AND FOR THE MINIMUM WARRANTY
        PERIOD ALLOWED BY THE MANDATORY APPLICABLE LAW.
      </p>
      <p>
        THE SCRIBBLES PARTIES DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME
        RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A
        THIRD PARTY THROUGH THE SITE, AND THE SCRIBBLES PARTIES WILL NOT BE A
        PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION
        BETWEEN YOU AND THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. YOU ARE
        SOLELY RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS AND INTERACTIONS WITH
        OTHER PERSONS WITH WHOM YOU COMMUNICATE OR INTERACT AS A RESULT OF YOUR
        USE OF THE SITE.
      </p>
      <p>
        If you are a California resident, you hereby waive California Civil Code
        §1542, which says: “A general release does not extend to claims that the
        creditor or releasing party does not know or suspect to exist in his or
        her favor at the time of executing the release and that, if known by him
        or her, would have materially affected his or her settlement with the
        debtor or released party.” This release includes the criminal acts of
        others.
      </p>
      <p>
        Some jurisdictions do not allow the exclusion of certain warranties or
        the limitation or exclusion of liability for incidental or consequential
        damages such as in this Section 9 or below in Section 11. Accordingly,
        some of these limitations may not apply to you. If you are a New Jersey
        resident, or a resident of another state that permits the exclusion of
        these warranties and liabilities, then the limitations in Section 9 and
        Section 11 specifically do apply to you.
      </p>
      <p>10. INDEMNIFICATION OBLIGATIONS</p>
      <p>
        You will defend, indemnify, and hold us, our Affiliates, officers,
        directors, employees, suppliers, consultants, and agents harmless from
        any and all third-party claims, liability, damages, and costs
        (including, but not limited to, attorneys' fees) arising from or related
        to, as applicable: (a) your access to and use of the Site; (b) violation
        of these Terms by you or your Account Administrator(s) or Authorized
        Users, as applicable; (c) infringement of any intellectual property or
        other right of any person or entity by you; (d) the nature and content
        of all Customer Data processed by the Services or any other services
        provided by Scribbles; or (e) any products or services purchased or
        obtained by you in connection with the Site.
      </p>
      <p>
        Scribbles retains the exclusive right to settle, compromise, and pay,
        without your prior consent, any and all claims or causes of action that
        are brought against us. We reserve the right, at your expense, to assume
        the exclusive defense and control of any matter for which you are
        required to indemnify us and you agree to cooperate with our defense of
        these claims. You agree not to settle any matter in which we are named
        as a defendant and/or for which you have indemnity obligations without
        our prior written consent. We will use reasonable efforts to notify you
        of any such claim, action, or proceeding upon becoming aware of it.
      </p>
      <p>11. LIMITATIONS OF LIABILITY</p>
      <p>
        11.1 Disclaimer of Consequential Damages. NOTWITHSTANDING ANYTHING TO
        THE CONTRARY CONTAINED IN THESE TERMS, SCRIBBLES WILL NOT, UNDER ANY
        CIRCUMSTANCES, BE LIABLE TO YOU FOR ANY CONSEQUENTIAL, INCIDENTAL,
        SPECIAL, COVER, PUNITIVE, OR EXEMPLARY DAMAGES ARISING OUT OF OR RELATED
        TO THE TRANSACTIONS CONTEMPLATED UNDER THESE TERMS, INCLUDING, BUT NOT
        LIMITED TO, GOODWILL, WORK STOPPAGE, LOST PROFITS, OR LOSS OF BUSINESS,
        EVEN IF APPRISED OF THE LIKELIHOOD OF SUCH LOSSES, AND WHETHER SUCH
        CLAIMS ARE MADE BASED ON CONTRACT, TORT (INCLUDING NEGLIGENCE), OR ANY
        OTHER LEGAL THEORY.
      </p>
      <p>
        TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE
        SCRIBBLES PARTIES BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL,
        SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES WHATSOEVER RESULTING FROM
        ANY: (a) USE OF THE SITE, DOCUMENTATION, OR ANY SCRIBBLES SERVICES; (b)
        ERRORS, MISTAKES, OR INACCURACIES OF CONTENT; (c) PERSONAL INJURY OR
        PROPERTY DAMAGE OF ANY NATURE WHATSOEVER RESULTING FROM YOUR ACCESS TO
        AND USE OF THE SITE, DOCUMENTATION, OR ANY SCRIBBLES SERVICES; (d) ANY
        UNAUTHORIZED ACCESS TO OR USE OF OUR SERVERS AND/OR ANY AND ALL PERSONAL
        INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN; (e) ANY
        INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM OUR SERVERS; (f)
        ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE THAT MAY BE TRANSMITTED TO
        OR THROUGH THE SITE, DOCUMENTATION, OR ANY SCRIBBLES SERVICES BY ANY
        THIRD PARTY; (g) ANY LOSS OF YOUR DATA OR CONTENT FROM THE SITE,
        DOCUMENTATION, OR ANY SCRIBBLES SERVICES; (h) ANY ERRORS OR OMISSIONS IN
        ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT
        OF YOUR USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE
        AVAILABLE VIA THE SITE, DOCUMENTATION, OR ANY SCRIBBLES SERVICES,
        WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), OR ANY
        OTHER LEGAL THEORY, AND WHETHER OR NOT THE SCRIBBLES PARTIES ARE ADVISED
        OF THE POSSIBILITY OF SUCH DAMAGES; AND/OR (i) THE DISCLOSURE OF
        INFORMATION PURSUANT TO THESE TERMS OR OUR PRIVACY POLICY.
      </p>
      <p>
        Some countries and jurisdictions do not allow the limitation or
        exclusion of consequential, direct, indirect, or other damages in
        contracts with consumers and to the extent you are a consumer the
        limitations or exclusions in this Section 11.1 may not apply to you.
      </p>
      <p>
        11.2 Cap on Damages. OUR TOTAL LIABILITY TO YOU FOR ANY CAUSE OF ACTION
        ARISING OUT OF OR RELATED TO THESE TERMS OR TO YOUR USE OF THE SITE
        (INCLUDING WITHOUT LIMITATION WARRANTY CLAIMS), REGARDLESS OF THE FORUM
        AND REGARDLESS OF WHETHER ANY ACTION OR CLAIM IS BASED ON CONTRACT, TORT
        (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL OR EQUITABLE THEORY, WILL NOT
        EXCEED THE TOTAL AMOUNT PAID BY YOU TO SCRIBBLES FOR THE SCRIBBLES
        SERVICE(S) GIVING RISE TO THE CLAIM UNDER THESE TERMS DURING THE TWELVE
        (12) MONTH PERIOD PRECEDING THE DATE OF THE FIRST EVENT GIVING RISE TO
        LIABILITY, OR $100, WHICHEVER IS GREATER. THE EXISTENCE OF MORE THAN ONE
        CLAIM SHALL NOT ENLARGE THIS LIMIT.
      </p>
      <p>
        11.3 Independent Allocations of Risk. Each provision of these Terms that
        provides for a limitation of liability, disclaimer of warranties, or
        exclusion of damages represents an agreed allocation of the risks of
        these Terms between the parties. This allocation is an essential element
        of the basis of the bargain between the parties. Each of these
        provisions is severable and independent of all other provisions of these
        Terms, and each of these provisions will apply even if the warranties in
        these Terms have failed of their essential purpose.
      </p>
      <p>
        11.4 Jurisdictional Limitations. Because some states and jurisdictions
        do not allow limitation of liability in certain instances, portions of
        the above limitation may not apply to you. In that event, such
        exclusions and limitations shall apply to the maximum extent permitted
        by applicable mandatory law (and our liability shall be limited or
        excluded as permitted under mandatory applicable law). If you are a New
        Jersey resident, the limitations in Section 11 specifically do apply to
        you.
      </p>
      <p>12. GENERAL</p>
      <p>
        12.1 Third Party Content. We may provide, or third parties may provide,
        links to other third-party web sites, services, or resources that are
        beyond our control. We make no representations as to the quality,
        suitability, functionality, or legality of any third-party content to
        which links may be provided, and you hereby waive any claim you might
        have against us with respect to such services. SCRIBBLES IS NOT
        RESPONSIBLE FOR THE CONTENT ON THE INTERNET OR WEB PAGES THAT ARE
        LOCATED OUTSIDE THE SITE OR POSTS OF USER CONTENT. Your correspondence
        or business dealings with, or participation in promotions of,
        advertisers or partners found on or through the Site, including payment
        and delivery of related goods or services, and any other terms,
        conditions, warranties, or representations associated with such
        dealings, are solely between you and such advertiser or partner. You
        agree that we are not responsible or liable for any loss or damage of
        any sort incurred as the result of any such dealings or as the result of
        the presence of such advertisers or links to third-party web sites or
        resources on the Site.
      </p>
      <p>
        12.2 Relationship. At all times, you and Scribbles are independent
        contractors, and are not the agents or representatives of the other.
        These Terms are not intended to create a joint venture, partnership, or
        franchise relationship between the parties. Non-parties do not benefit
        from and cannot enforce these Terms. There are no third-party
        beneficiaries to these Terms. You must not represent to anyone that you
        are an agent of Scribbles or are otherwise authorized to bind or commit
        Scribbles in any way without Scribbles’ prior written authorization.
      </p>
      <p>
        12.3 Export Control Laws. You acknowledge that the Site, Documentation,
        and/or Scribbles Services and any related products, information,
        documentation, Software, technology, technical data, and any derivatives
        thereof, that Scribbles makes available (collectively “Excluded Data”)
        is subject to export control laws and regulations of the United States
        (including, without limitation, the U.S. Export Administration Act and
        the sanctions regulations administered by the U.S. Department of the
        Treasury Office of Foreign Assets Control (“OFAC”)) and other
        jurisdictions (collectively “Export Laws”). You represent and warrant
        that you will not access, download, use, export, or re-export, directly
        or indirectly, the Excluded Data to any location, entity, government or
        person prohibited by Export Laws (including, without limitation, to any
        end user in a U.S. embargoed country or territory or an end user
        included on OFAC’s listing of Specially Designated Nationals or the U.S.
        Commerce Department’s Entity List or Denied Persons List) without first
        complying with all Export Laws that may be imposed by the U.S.
        Government and any country or organization of nations within whose
        jurisdiction you operate or do business. You are solely responsible for
        complying with Export Laws for all Excluded Data and any of its content
        transmitted through the Site.
      </p>
      <p>
        12.4 Assignability. You may not assign your rights or obligations under
        these Terms without Scribbles’ prior written consent. If consent is
        given, these Terms will bind your successors and assigns. Any attempt by
        you to transfer your rights, duties, or obligations under these Terms
        except as expressly provided in these Terms is void. Scribbles may
        freely assign its rights, duties, and obligations under these Terms.
      </p>
      <p>
        12.5 Notices. Except as otherwise permitted by these Terms, any notice
        required or permitted to be given in connection with the Services will
        be effective only if it is in writing and sent using: (a) the Services;
        (b) by certified or registered mail; or (c) insured courier, to the
        appropriate party at the address set forth in Customer’s registration
        information or on the Site for Scribbles, with a copy, in the case of
        Scribbles, to{' '}
        <a href="mailto:support@scribsoft.com">support@scribsoft.com</a>.
        Customer or Scribbles may change its address for receipt of notice by
        notice to the other party in accordance with this Section 12.5. Notices
        are deemed given upon receipt if delivered using the Services, three (3)
        business days following the date of mailing by U.S. first class mail, or
        one (1) business day following delivery to a courier for overnight
        delivery.
      </p>
      <p>
        12.6 Force Majeure. Except for any payment obligations, neither you nor
        Scribbles will be liable for failure to perform any obligation under
        these Terms to the extent such failure is caused by a force majeure
        event (including acts of God, natural disasters, war, civil disturbance,
        action by governmental entity, strike, and other causes beyond the
        party’s reasonable control). The party affected by the force majeure
        event will provide notice to the other party within a commercially
        reasonable time and will use commercially reasonable efforts to resume
        performance as soon as practicable. Obligations not performed due to a
        force majeure event will be performed as soon as reasonably possible
        when the force majeure event concludes.
      </p>
      <p>
        12.7 Mandatory Arbitration, Waiver of Class Actions Applicable to
        Customers.
      </p>
      <p>
        PLEASE READ THIS SECTION CAREFULLY. IT AFFECTS YOUR LEGAL RIGHTS,
        INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT.
      </p>
      <p>
        12.7.1 You agree that these Terms affect interstate commerce and that
        the Federal Arbitration Act governs the interpretation and enforcement
        of these arbitration provisions. This Section 12.7 is intended to be
        interpreted broadly and governs any and all disputes between us
        including but not limited to claims arising out of or relating to any
        aspect of the relationship between us, whether based in contract, tort,
        statute, fraud, misrepresentation, or any other legal theory; claims
        that arose before these Terms or any prior; and claims that may arise
        after the termination of these Terms. The only disputes excluded from
        this broad prohibition are the litigation of certain intellectual
        property as provided below.
      </p>
      <p>
        12.7.2 Initial Dispute Resolution. Most disputes can be resolved without
        resort to arbitration. If you have any dispute with us, you agree that
        before taking any formal action you will contact us at{' '}
        <a href="mailto:legal@scribsoft.com">legal@scribsoft.com</a> and provide
        a brief, written description of the dispute and your contact information
        (including your username, if your dispute relates to an Account). Except
        for intellectual property, you and Scribbles agree to use your
        respective reasonable efforts to settle any dispute, claim, question, or
        disagreement directly through consultation with Scribbles, and good
        faith negotiations shall be a condition to either party initiating a
        lawsuit or arbitration.
      </p>
      <p>
        12.7.3 Binding Arbitration. If the parties do not reach an agreed-upon
        solution within a period of thirty (30) days from the time informal
        dispute resolution is initiated under the Initial Dispute Resolution
        provision above, then either party may initiate binding arbitration as
        the sole means to resolve claims (except as provided below) subject to
        these Terms set forth below. Specifically, all claims arising out of or
        relating to these Terms, the parties' relationship with each other,
        and/or your use of the Scribbles Services shall be finally settled by
        binding arbitration administered by JAMS in accordance with the JAMS
        Streamlined Arbitration Procedure Rules for claims that do not exceed
        $250,000 and the JAMS Comprehensive Arbitration Rules and Procedures for
        claims exceeding $250,000 in effect at the time the arbitration is
        initiated, excluding any rules or procedures governing or permitting
        class actions. If JAMS is not available to administer an arbitration in
        Mecklenburg County, North Carolina, a different arbitration services
        firm will be selected by Scribbles at its discretion and the applicable
        rules from that alternative arbitration services firm will apply.
      </p>
      <p>
        12.7.4 Arbitrator’s Powers. The arbitrator, and not any federal, state,
        or local court or agency, shall have exclusive authority to resolve all
        disputes arising out of or relating to the interpretation,
        applicability, enforceability, or formation of these Terms, including
        but not limited to any claim that all or any part of these Terms is void
        or voidable, whether a claim is subject to arbitration or the question
        of waiver by litigation conduct. The arbitrator shall be empowered to
        grant whatever relief would be available in a court under law or in
        equity. The arbitrator's award shall be written and shall be binding on
        the parties and may be entered as a judgment in any court of competent
        jurisdiction.
      </p>
      <p>
        12.7.5 Filing a Demand. To start an arbitration, you must do the
        following: (a) Write a Demand for Arbitration that includes a
        description of the claim and the amount of damages you seek to recover
        (you may find a copy of a Demand for Arbitration at www.jamsadr.com);
        (b) Send three copies of the Demand for Arbitration, plus the
        appropriate filing fee, to JAMS, One Atlantic Center, 1201 West
        Peachtree, NW, Atlanta, GA 30309; and (c) Send one copy of the Demand
        for Arbitration to us at:{' '}
        <a href="mailto:legal@scribsoft.com">legal@scribsoft.com.</a>
      </p>
      <p>
        12.7.6 Fees & Costs. If your claim(s) total is less than US $5,000.00,
        then: (a) you may choose whether your participation in the arbitration
        will be conducted on the basis of documents provided to the arbitrator,
        through a telephonic hearing or by an in-person hearing; (b) Scribbles
        will reimburse your filing fees up to a maximum of US $1,500.00 unless
        the arbitrator determines that your claims are frivolous; and (c)
        Scribbles will not seek attorney’s fees and costs, unless the arbitrator
        determines that your claims are frivolous. You are responsible for your
        own attorneys' fees unless the arbitration rules and/or applicable law
        provide otherwise.
      </p>
      <p>
        12.7.7 No Jury Trial. The parties understand that, absent this mandatory
        arbitration section, they would have the right to sue in court and have
        a jury trial. They further understand that, in some instances, the costs
        of arbitration could exceed the costs of litigation and the right to
        discovery may be more limited in arbitration than in court.
      </p>
      <p>
        12.7.8 Venue. Arbitration shall be initiated and take place in
        Mecklenburg County, North Carolina, United States, and you and Scribbles
        agree to submit to the personal jurisdiction of any federal or state
        court in Mecklenburg County, North Carolina in order to compel
        arbitration, stay proceedings pending arbitration, or to confirm,
        modify, vacate, or enter judgment on the award entered by the
        arbitrator.
      </p>
      <p>
        12.7.9 Class Action Waiver. The parties further agree that the
        arbitration shall be conducted in the party’s respective individual
        capacities only and not as a class action or other representative
        action, and the parties expressly waive their right to file a class
        action or seek relief on a class basis. YOU AND SCRIBBLES AGREE THAT
        EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL
        CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS
        OR REPRESENTATIVE PROCEEDING. If any court or arbitrator determines that
        the class action waiver set forth in this paragraph is void or
        unenforceable for any reason or that an arbitration can proceed on a
        class basis, then the arbitration provisions set forth above shall be
        deemed null and void in their entirety and the parties shall be deemed
        to have not agreed to arbitrate disputes.
      </p>
      <p>
        12.7.10 Exception: Litigation of Intellectual Property. Notwithstanding
        the parties' decision to resolve all disputes through arbitration,
        either party may bring enforcement actions, validity determinations, or
        claims arising from or relating to theft, piracy, or unauthorized use of
        intellectual property in any state or federal court with jurisdiction or
        in the U.S. Patent and Trademark Office to protect its intellectual
        property rights (“intellectual property rights” means patents,
        copyrights, moral rights, trademarks, and trade secrets, but not privacy
        or publicity rights).
      </p>
      <p>
        12.7.11 Survival. This Mandatory Arbitration, Waiver of Class Actions
        section shall survive any termination of your use of the Site.
      </p>
      <p>
        12.8 Entire Terms.These Terms, which include the language and paragraphs
        preceding Section 1, are the final, complete, and exclusive expression
        of the agreement between you and Scribbles regarding the Services
        provided under these Terms. These Terms supersede and the parties
        disclaim any reliance on previous oral and written communications
        (including any confidentiality agreements pertaining to the Scribbles
        Services under these Terms) with respect to the subject matter hereof
        and apply to the exclusion of any other terms that you seek to impose or
        incorporate, or which are implied by trade, custom, practice or course
        of dealing. Scribbles hereby rejects any additional or conflicting terms
        appearing in a purchase order or any other ordering materials submitted
        by Customer and conditions assent solely based on these Terms and
        conditions of these Terms as offered by Scribbles. Except as explicitly
        permitted in these Terms, no modification or amendment of these Terms
        shall be effective unless it is in writing and signed by an authorized
        agent of the party against whom the modification or amendment is being
        asserted. In the event of an inconsistency or conflict, the order of
        precedence in descending order of control is as follows: (a) the
        Subscription Plan; (b) any attachments or appendix(ices) to the Service
        Schedule(s); (c) the Service Schedule; (d) these Terms and (e) the
        Customer Terms.
      </p>
      <p>
        12.9 Governing Law & Venue. These Terms will be interpreted, construed,
        and enforced in all respects in accordance with the local laws of the
        State of North Carolina, U.S.A., without reference to any choice of law
        rules to the contrary of any jurisdiction. For purposes of determining
        the governing law, you and Scribbles agree that Scribbles is the
        proponent of these Terms. Notwithstanding Customer’s and Scribbles’
        agreement to mandatory arbitration, either party may seek any interim or
        preliminary injunctive relief from a court of competent jurisdiction in
        Mecklenburg County, North Carolina, as necessary to protect the party's
        rights or property pending the completion of arbitration. Customer and
        Scribbles submit to the exclusive jurisdiction of, and venue in, any
        federal or state court of competent jurisdiction located in Mecklenburg
        County, North Carolina.
      </p>
      <p>
        12.11 Language and Translations. Scribbles may provide translations of
        these Terms or other terms or policies. Translations are provided for
        informational purposes and if there is an inconsistency or conflict
        between a translation and the English version, the English version will
        control.
      </p>
      <p>
        12.12 Waiver. The waiver by either you or Scribbles of any breach of any
        provision of these Terms does not waive any other breach. The failure of
        any party to these Terms to insist on strict performance of any covenant
        or obligation in accordance with these Terms will not be a waiver of
        such party’s right to demand strict compliance in the future, nor will
        the same be construed as a novation of these Terms.
      </p>
      <p>
        12.13 Severability. If any part of these Terms is found to be illegal,
        unenforceable, or invalid, the remaining portions of these Terms will
        remain in full force and effect. If any material limitation or
        restriction on the grant of any license to you under these Terms is
        found to be illegal, unenforceable, or invalid, the license will
        immediately terminate.
      </p>
      <p>
        12.14 How to Contact Us. If you have any questions about the Site or
        Terms, pricing, complaints, or other inquiries, please contact Scribbles
        at <a href="mailto:support@scribsoft.com">support@scribsoft.com</a>, or
        by calling us at +1 (877) 287-6K12. California users are also entitled
        to the following specific consumer rights notice: The Complaint
        Assistance Unit of the Division of Consumer Services of the California
        Department of Consumer Affairs may be contacted in writing at 1625 North
        Market Blvd., Sacramento, CA 95834, or by telephone at (916) 445-1254 or
        (800) 952-5210.
      </p>
    </p>

    <p>
      <h5>SERVICE SCHEDULE for SCRIBBLES SIGNATURE SERVICES</h5>
      <p>
        This Service Schedule was last updated on December 1, 2019. Unless
        otherwise defined in this Service Schedule, capitalized terms will have
        the meaning given to them in the Terms.
      </p>
      <p>1. DEFINITIONS</p>
      <p>
        “Scribbles Signature” means the on-demand electronic signature Scribbles
        Signature Services, that provides online display, certified delivery,
        acknowledgement, electronic signature, and storage services for
        electronic documents via the Internet.
      </p>
      <p>
        “Document Package” means an electronic record containing one or more
        electronic documents consisting of a single page or a group of pages of
        data uploaded to the System.
      </p>
      <p>
        “System” refers to the software systems and programs, the communication
        and network facilities, and the hardware and equipment used by Scribbles
        or its agents to provide the Scribbles Signature Services.
      </p>
      <p>
        “Transaction Data” means the metadata associated with an Document
        Package (such as transaction history, associated hash values, method and
        time of Document Package deletion, sender and recipient names, email
        addresses, and signature identifiers) and maintained by Scribbles in
        order to establish the digital audit trail required by the Scribbles
        Signature.
      </p>
      <p>2. ADDITIONAL USAGE LIMITATIONS AND CUSTOMER RESPONSIBILITIES</p>
      <p>
        2.1 Scribbles’ provision of the Scribbles Signature service is
        conditioned on Customer’s acknowledgement of and agreement to the
        following:
      </p>
      <p>
        (a) Scribbles Signature facilitates the execution of Electronic
        Documents between the parties to those Electronic Documents. Nothing in
        this Schedule may be construed to make Scribbles a party to any document
        processed through Scribbles Signature Services, and Scribbles makes no
        representation or warranty regarding the transactions sought to be
        effected by any document;
      </p>
      <p>
        (b) Certain types of agreements and documents may be excepted from
        electronic signature laws, or may be subject to specific regulations
        promulgated by various government agencies regarding electronic
        signatures and electronic records. Scribbles is not responsible for
        determining whether any particular document is (i) subject to an
        exception to applicable electronic signature laws; (ii) subject to any
        particular agency promulgations; or (iii) whether it can be legally
        formed by electronic signatures;
      </p>
      <p>
        (c) Scribbles is not responsible for determining how long any contracts,
        documents, and other records are required to be retained or stored under
        any applicable laws, regulations, or legal or administrative agency
        processes.Further, Scribbles is not responsible for providing Customer’s
        Electronic Documents or other documents to third parties;
      </p>
      <p>
        (d) Certain consumer protection or similar laws or regulations may
        impose special requirements with respect to electronic transactions
        involving one or more “consumers,” such as (among others) requirements
        that the consumer consent to the method of contracting and/or that the
        consumer be provided with a copy, or access to a copy, of a paper or
        other non-electronic, written record of the transaction. Scribbles does
        not and is not responsible to: (i) determine whether any particular
        transaction involves a “consumer;” (ii) furnish or obtain any such
        consents or determine if any such consents have been withdrawn; (iii)
        provide any information or disclosures in connection with any attempt to
        obtain any such consents; (iv) provide legal review of, or update or
        correct any information or disclosures currently or previously given;
        (v) provide any such copies or access, except as expressly provided in
        the Documentation for all transactions, consumer or otherwise; or (vi)
        otherwise to comply with any such special requirements; and
      </p>
      <p>
        (e) Customer undertakes to determine whether any “consumer” is involved
        in any Electronic Document presented by its Authorized Users for
        processing, and, if so, to comply with all requirements imposed by law
        on such Electronic Documents or their formation.
      </p>
      <p>
        (f) Customer agrees that its assigned Account Administrator(s) has
        authority to provide Scribbles with and accept from Scribbles any
        acknowledgments, authorizations, requests, or consents on behalf of
        Customer with respect to Customer’s Account.
      </p>
      <p>
        (g) Customer agrees it is solely responsible for the accuracy and
        appropriateness of instructions given by it and its personnel to
        Scribbles in relation to the Services, including without limitations
        through its Account as made by the assigned Account Administrator(s).
      </p>
      <p>
        2.2 Subscription Plans purchased on Scribbles.com may not be used in
        conjunction with Scribbles APIs and are available for use with a limited
        number of integrations.
      </p>
      <p>3. ELECTRONIC DOCUMENT STORAGE AND DELETION</p>
      <p>
        3.1 Sending, Storage. During the Term Scribbles will send and store
        Electronic Documents per these Terms of the Subscription Plan. However,
        Scribbles may set and enforce limits for reasonable use in order to
        prevent abusive or unduly burdensome use of Scribbles Signature.
        Customer, through its Account Administrator(s), may retrieve and store
        copies of Electronic Documents for storage outside of the System at any
        time during the Subscription Term when Customer is in good financial
        standing under these Terms, and may delete or purge Electronic Documents
        from the System at its own discretion.
      </p>
      <p>
        3.2 Uncompleted Electronic Documents. Scribbles may, at its sole
        discretion, delete uncompleted Electronic Documents from the System
        immediately and without notice upon the earlier of: (a) expiration of
        the Document Package (where Customer has established an expiration for
        such Document Package, not to exceed 365 days); or (b) expiration of the
        Subscription Term. Scribbles assumes no liability or responsibility for
        a party’s failure or inability to electronically sign any Electronic
        Documents within such a period of time.
      </p>
      <p>
        3.3 Deletion. Scribbles may delete an Account and Customer Data,
        including without limitation Electronic Documents (whether complete or
        not), upon the expiration of the Subscription Term or termination as
        described in Section 8.2 of the Terms.
      </p>
      <p>
        3.4 Retention of Transaction Data. Scribbles may retain Transaction Data
        for as long as it has a business purpose to do so.
      </p>
      <p>4. INFORMATION SECURITY AND PERSONAL DATA</p>
      <p>
        4.1 Customer Responsibilities. Scribbles Signature provides Customer
        with certain features and functionalities that Customer may elect to
        use, including the ability to retrieve and delete Electronic Documents
        in the System. Customer is responsible for properly: (a) configuring
        Scribbles Signature; (b) using and enforcing controls available in
        connection with Scribbles Signature (including any security controls);
        and (c) taking such steps, in accordance with the functionality of
        Scribbles Signature, that Customer deems adequate to maintain
        appropriate security, protection, deletion, and backup of Customer Data,
        which include controlling the management of Authorized Users’ access and
        credentials to Scribbles Signature, controlling Customer Data that is
        Processed by Scribbles Signature, and controlling the archiving or
        deletion of Electronic Documents in the System. Customer acknowledges
        that Scribbles has no obligation to protect Customer Data, including
        Personal Data (defined below), that Customer elects to store or transfer
        outside of Scribbles Signature (e.g., offline or on-premise storage).
      </p>
      <p>
        4.2 Information Security. Scribbles will employ commercially reasonable
        technical and organizational measures that are designed to prevent
        unlawful or unauthorized access, use, alteration, or disclosure of
        Customer Data.
      </p>
      <p>5. ACCOUNTS & ORGANIZATIONAL ADMINISTRATION</p>
      <p>
        5.1 Each Account is associated with a single email address. If the
        domain of the primary email address associated with an Account is owned
        by a business or other organization (“Entity”) and was assigned to
        Customer as an employee, contractor or member of the Entity, such as
        yourname@youremployer.com or yourname@nonprofit.org (“Entity Email
        Address”), Customer grants that Entity and its Account Administrator(s)
        permission to: (a) identify Accounts created with an Entity Email
        Address; and (b) restrict or terminate access to an Account created with
        an Entity Email Address. Customer acknowledges and agrees that Scribbles
        may assist Entity with such administration.
      </p>
      <p>6. SUBSCRIPTION PLANS & PRICES</p>
      <p>
        6.1 The prices, features, and options of Scribbles Signature depend on
        the Subscription Plan selected, if any, by Customer as well as any
        changes instigated by Customer. For example: (a) if Customer adds
        Authorized Users, Scribbles will charge the applicable subscription
        amount for each additional Authorized User; or (b) if Customer sends
        more Document Packages than are included in your Subscription Plan,
        Scribbles may charge for additional Document Packages or assign Customer
        to a new Subscription Plan.Customer may also purchase optional services
        on a periodic or per-use basis. Scribbles may change the prices for or
        alter the features and options in a particular Subscription Plan without
        notice.
      </p>
    </p>

    <p style={{ marginBottom: '90px' }}>
      <h5>Contacting Scribbles</h5>
      <p>
        Please also feel free to contact us if you have any questions about
        Scribbles Software’s Shared Responsibility Model. You may contact us at
        <a href="mailto:support@scribsoft.com">support@scribsoft.com</a> or at
        our mailing address below:
        <address>
          <br />
          <strong>Scribbles Software, LLC</strong>
          <br />
          10617 Southern Loop Blvd
          <br />
          Pineville, NC 28134
        </address>
      </p>
    </p>
  </div>
);
